import React from "react"
import {
  Grid,
  Typography,
  DialogActions,
  Button,
  DialogContent,
  Dialog,
  DialogTitle,
  Toolbar,
} from "@material-ui/core"
import moment from "moment"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableRow from "@material-ui/core/TableRow"
import { GridList, GridListTile } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import napformat from "../../../../../config/napformat"

const useStyles = makeStyles( ( theme ) => ( {
  table: { background: "#fff" },
  subtitle: { justifyContent: "center" },
  imagen: {
    border: "5px solid #eee",
    maxWidth: "55%",
    marginLeft: "22%",
    borderRadius: 5,
    marginBottom: 5,
  },
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
} ) )

const ModalDetailsIntangibles = ( props ) => {
  const classes = useStyles()
  const { visible, setVisible, dataIntangibles } = props

  return (
    <Dialog maxWidth="lg" fullScreen open={ visible }>
      <DialogTitle>
        <Grid container>
          <Grid item xs={ 1 }>
          </Grid>
          <Grid item xs={ 10 }>
            <Typography
              variant="h2"
              component="h2"
              color="textSecondary"
              align="center"
            >
              DETALLES
            </Typography>
          </Grid>
          <Grid item xs={ 1 }>
            <Button
              color="secondary"
              variant="contained"
              onClick={ () => setVisible( false ) }
            >
              Cerrar
            </Button>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={ 1 }>
          <Grid item xs={ 12 } md={ 6 }>
            <Grid container spacing={ 1 }>
              <Grid item xs={ 12 }>
                <TableContainer>
                  <Toolbar className={ classes.subtitle }>
                    <Typography
                      variant="h4"
                      color="textSecondary"
                      gutterBottom
                      align="center"
                    >
                      Información General
                    </Typography>
                  </Toolbar>
                  <Table
                    className={ classes.table }
                    aria-label="simple table"
                    size="small"
                  >
                    <TableBody>
                      <TableRow>
                        <TableCell style={ { width: 175 } }>Categoria</TableCell>
                        <TableCell align="right">
                          { dataIntangibles.category.name }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={ { width: 175 } }>
                          Sub Categoria
                        </TableCell>
                        <TableCell align="right">
                          { dataIntangibles.subcategory?.name ?? "" }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={ { width: 175 } }>
                          Cuenta contable
                        </TableCell>
                        <TableCell align="right">
                          { dataIntangibles.category.account_number }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={ { width: 175 } }>
                          Nombre de la cuenta
                        </TableCell>
                        <TableCell align="right">
                          { dataIntangibles.category.account_name }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" scope="row">
                          DESCRIPCIÓN TÉCNICA:
                        </TableCell>
                        <TableCell align="right" scope="row">
                          { dataIntangibles.description
                            ? dataIntangibles.description
                            : "-" }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" scope="row">
                          Código de Licencia:
                        </TableCell>
                        <TableCell align="right" scope="row">
                          { dataIntangibles.serie ? dataIntangibles.serie : "-" }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" scope="row">
                          Fecha de adquisición:
                        </TableCell>
                        <TableCell align="right" scope="row">
                          { dataIntangibles.acquisition_date
                            ? moment( dataIntangibles.acquisition_date ).format(
                              "DD/MM/YYYY"
                            )
                            : "-" }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" scope="row">
                          Cantidad:
                        </TableCell>
                        <TableCell align="right" scope="row">
                          { dataIntangibles.amount
                            ? dataIntangibles.amount
                            : "-" }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left" scope="row">
                          Valor unitario:
                        </TableCell>
                        <TableCell align="right" scope="row">
                          { dataIntangibles.unit_value ? (
                            <>S/{ napformat( dataIntangibles.unit_value ) }</>
                          ) : (
                            " - "
                          ) }
                        </TableCell>
                      </TableRow>
                      <TableRow></TableRow>
                      <TableRow>
                        <TableCell align="left" scope="row">
                          Valor histórico:
                        </TableCell>
                        <TableCell align="right" scope="row">
                          { dataIntangibles.historical_value ? (
                            <>S/{ napformat( dataIntangibles.historical_value ) }</>
                          ) : (
                            " - "
                          ) }
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={ 12 } md={ 6 }>
            <Grid container spacing={ 1 }>
              <Grid item xs={ 12 }>
                <Grid
                  container
                  spacing={ 1 }
                  direction="column"
                  alignItems="center"
                  justify="center"
                >
                  <div className={ classes.root }>
                    <GridList
                      cellHeight={ 160 }
                      className={ classes.gridList }
                      cols={ 3 }
                    >
                      { dataIntangibles.images.map( ( tile, index ) => (
                        <GridListTile key={ tile } cols={ 1 }>
                          <img src={ tile } alt={ tile } />
                        </GridListTile>
                      ) ) }
                    </GridList>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={ 12 }>
            <Grid container spacing={ 1 }>
              { dataIntangibles.docs &&
                dataIntangibles.docs.length > 0 &&
                dataIntangibles.docs.map( ( ev, index ) => (
                  <Grid item xs={ 12 } md={ 6 }>
                    <embed
                      src={ ev }
                      type="application/pdf"
                      width="100%"
                      height="400px"
                    />
                  </Grid>
                ) ) }
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalDetailsIntangibles
